import { render, staticRenderFns } from "./SSSignUpView.vue?vue&type=template&id=f9a5f67c&scoped=true&"
import script from "./SSSignUpView.vue?vue&type=script&lang=js&"
export * from "./SSSignUpView.vue?vue&type=script&lang=js&"
import style0 from "./SSSignUpView.vue?vue&type=style&index=0&id=f9a5f67c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a5f67c",
  null
  
)

export default component.exports